export default __webpack_public_path__ + "static/media/goopter-use-case-dining-automation.6a57c9c1.jpeg";